import { StringArrayMiddlewareUtils } from '../shared/middlewareUtils';

/**
 * 通用多选筛选器中间件工具
 * value 类型：string[]
 */
class MultipleSelectMiddlewareUtils extends StringArrayMiddlewareUtils {}

export default MultipleSelectMiddlewareUtils;
